module.exports = __webpack_public_path__ + "static/img/img_pb_produ.e3a140f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_pb_produ.png
// module id = aNq0
// module chunks = 1